export default '/build/cf539e7d.svg'